module.exports = __webpack_public_path__ + "static/media/purepapermetal-skin-champagne-brushed-4051-scale.9b7b8132.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapermetal-skin-champagne-brushed-4051-scale.jpg
// module id = 1115
// module chunks = 37